import { render, staticRenderFns } from "./StatisticalCard.vue?vue&type=template&id=700feaee&scoped=true"
import script from "./StatisticalCard.vue?vue&type=script&lang=js"
export * from "./StatisticalCard.vue?vue&type=script&lang=js"
import style0 from "./StatisticalCard.vue?vue&type=style&index=0&id=700feaee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700feaee",
  null
  
)

export default component.exports